import { useEffect, useRef } from 'react';
import type { CreditCardViewProps } from '../types/credit-card.types';

export const useCreditCard = (props: CreditCardViewProps) => {
  const hasNotified = useRef(false);
  
  // Notificar venda para Shopify se os dados estiverem disponíveis (apenas uma vez)
  useEffect(() => {
    if (props.shopifyData && !hasNotified.current) {
      hasNotified.current = true;
      // Comentado para evitar duplicação - sistema unificado já cria o pedido
      // notifySaleToBackend(props.shopifyData);
    }
  }, [props.shopifyData]);

  return {
    // Hook pode ser expandido no futuro se necessário
  };
}; 